import * as marietta from '../..';
import Dialog from './Dialog';

export default class ConfirmDialog {
    viewObj: HTMLElement;

    _draggable: Boolean = true;

    globalCleanUpFunc: Function;

    dialogOffset: marietta.core.Point;

    dialogPosition: marietta.core.Point;

    static callbackYes: Function;

    static callbackNo: Function;

    showHeaderCloseButton: boolean = true;

    prevDialog:Dialog;

    /**
     * ダイアログの作成
     */
    show(message: string, title: string = '', cbYes: Function = null, cbNo: Function = null, showCloseButton: boolean = true, _prevDialog = null) {
      marietta.core.view.ConfirmDialog.callbackYes = cbYes;
      marietta.core.view.ConfirmDialog.callbackNo = cbNo;
      this.prevDialog = _prevDialog;
      this.showHeaderCloseButton = showCloseButton;

      // お掃除
      if (document.querySelector('#confirmDialog') != null)document.querySelector('#confirmDialog').remove();

      // エレメント初期化
      this.viewObj = document.createElement('div');
      this.viewObj.setAttribute('id', 'confirmDialog');
      this.viewObj.classList.add('dialogBox');
      if (this.prevDialog) {
        const zIndex = Number(getComputedStyle((this.prevDialog.viewObj)).zIndex);
        this.viewObj.style.zIndex = String(zIndex + 2);
      }
      let elHeader = '';
      let elBody = '';
      let elFooter = '';

      // ヘッダー生成
      elHeader += '<div class="dialogHeader">\n';
      if (this.showHeaderCloseButton) {
        elHeader += '<div class="dialogClose"><button class="dialogCloseBtn"><i class="icon icon-close4">×</i></button></div>\n';
      }
      elHeader += `<div class="dialogTitle">${title}</div>`;
      elHeader += '</div>';

      // ボディ生成
      elBody += '<div class="dialogBody">\n';
      elBody += message;
      elBody += '</div>';

      // コントロールバー(フッター)生成
      elFooter += '<div class="dialogFooter">\n';
      elFooter += '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
      elFooter += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';
      elFooter += '</div>';

      const element = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };

      this.viewObj.appendChild(element(elHeader));
      this.viewObj.appendChild(element(elBody));
      this.viewObj.appendChild(element(elFooter));

      const buttons = this.viewObj.querySelectorAll('button');
      for (let i: number = 0; i < buttons.length; i += 1) {
        buttons[i].addEventListener('click', this.btnEventHandler);
      }

      // ダイアログ用コンテナに追加
      const container = document.querySelector('#dialogContainer');
      container.appendChild(this.viewObj);

      this.viewObj.style.display = 'block';
      // ダイアログの移動
      const self = this;
      if (this._draggable) {
        if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
          document.querySelector('.dialogHeader').addEventListener('touchstart', self.headerMouseDownHandler);
          // タイトルバーの×ボタン
          if (this.showHeaderCloseButton) {
            this.viewObj.querySelector('.dialogCloseBtn').addEventListener('touchend', this.close, { passive: false });
          }
        } else {
          document.querySelector('.dialogHeader').addEventListener('mousedown', self.headerMouseDownHandler);
          // タイトルバーの×ボタン
          if (this.showHeaderCloseButton) {
            this.viewObj.querySelector('.dialogCloseBtn').addEventListener('click', this.close);
          }
        }
        (<HTMLElement>document.querySelector('.dialogHeader')).style.cursor = 'move';
        this.dialogOffset = new marietta.core.Point(0, 0);
        this.dialogPosition = new marietta.core.Point(0, 0);
      }
      this.handleModal();
    }

    /**
     * ダイアログを閉じる
     */
    close = () => {
      this.viewObj.remove();
      if (this.showHeaderCloseButton) {
        this.viewObj.querySelector('.dialogCloseBtn').removeEventListener('click', this.close);
      }

      if (this.prevDialog) {
        marietta.webcad.WebCADGlobal.currentDialog = this.prevDialog;
        if (marietta.webcad.WebCADGlobal.currentDialog.hasModal)marietta.webcad.WebCADGlobal.currentDialog.handleModal();
      }

      // コールバックのお掃除関数
      this.globalCleanUpFunc();
    }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e: Event) => {
      console.log('btnEventHandler');

      const self: ConfirmDialog = this;
      e.preventDefault();
      if ((<HTMLButtonElement>e.currentTarget).value) {
        if (marietta.core.view.ConfirmDialog.callbackYes != null) {
          marietta.core.view.ConfirmDialog.callbackYes();
        }
      } else if (marietta.core.view.ConfirmDialog.callbackNo != null) {
        marietta.core.view.ConfirmDialog.callbackNo();
      }
      self.close();
    }

    /**
     * いいえボタンがクリックされた
     */
    onBtnNOClicked = () => {
      this.close();
    }

    // /**
    //  * 内容の追加
    //  */
    // buildContent() {
    //   // overrideして使用.
    // }

    /**
     * ダイアログを中心へ
     */
    centerDialog() {
      // ダイアログの幅調整
      let maxW: number = 0;

      for (let i:number = 0; i < this.viewObj.children.length; i += 1) {
        const child: HTMLElement = this.viewObj.children[i] as HTMLElement;
        if (maxW < child.getBoundingClientRect().width) {
          maxW = Math.ceil(child.getBoundingClientRect().width);
        }
        child.style.display = 'block';
      }
      this.viewObj.style.width = `${maxW}px`;

      // ダイアログの高さ調整
      let boxHeight: number = 0;
      for (let i:number = 0; i < this.viewObj.children.length; i += 1) {
        boxHeight += this.viewObj.children[i].getBoundingClientRect().height;
      }
      this.viewObj.style.height = `${boxHeight}px`;
    }

    /**
     * ダイアログの移動開始
     */
    headerMouseDownHandler = (e: any) => {
      e.preventDefault();
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        // パネルのクリック位置格納
        this.dialogOffset.x = (<TouchEvent>e.originalEvent).targetTouches[0].pageX;
        this.dialogOffset.y = (<TouchEvent>e.originalEvent).targetTouches[0].pageY;
        document.addEventListener('touchmove', this.headerMouseMoveHandler, { passive: false });
        document.addEventListener('touchend', this.headerMouseUpHandler, { passive: false });
      } else {
        // パネルのクリック位置格納
        this.dialogOffset.x = e.clientX;
        this.dialogOffset.y = e.clientY;
        document.addEventListener('mousemove', this.headerMouseMoveHandler);
        document.addEventListener('mouseup', this.headerMouseUpHandler);
      }
    }

    headerMouseMoveHandler = (e: MouseEvent | TouchEvent) => {
      e.preventDefault();
      let posX: number;
      let posY: number;
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        posX = (<TouchEvent>e).targetTouches[0].pageX - this.dialogOffset.x + this.dialogPosition.x;
        posY = (<TouchEvent>e).targetTouches[0].pageY - this.dialogOffset.y + this.dialogPosition.y;
      } else {
        posX = (<MouseEvent>e).clientX - this.dialogOffset.x + this.dialogPosition.x;
        posY = (<MouseEvent>e).clientY - this.dialogOffset.y + this.dialogPosition.y;
      }
      const cssTransform: string = `translate(${posX}px,${posY}px)`;
      this.viewObj.style.transform = cssTransform;
    }

    /**
     * ヘッダーがマウスアップされた
     * @param {MouseEvent | TouchEvent} e
     */
    headerMouseUpHandler = (e: MouseEvent | TouchEvent) => {
      e.preventDefault();
      // transformで移動したパネルの配置格納
      const cssVal = this.viewObj.style.transform;
      if (cssVal.indexOf('matrix') > -1) {
        const cssValTemp: string[] = cssVal.split(', ');
        this.dialogPosition.x = parseInt(cssValTemp[4], 10);
        this.dialogPosition.y = parseInt(cssValTemp[5].split(')')[0], 20);
      }
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        document.removeEventListener('touchmove', this.headerMouseMoveHandler);
        document.removeEventListener('touchend', this.headerMouseUpHandler);
      } else {
        document.removeEventListener('mousemove', this.headerMouseMoveHandler);
        document.removeEventListener('mouseup', this.headerMouseUpHandler);
      }
    }

    handleModal = () => {
      document.getElementById('modalBg').style.display = 'block';
      const zIndex = Number(getComputedStyle(this.viewObj).zIndex);
      document.getElementById('modalBg').style.zIndex = String(zIndex - 1);
    }
}
